import router from "../../routes";
import { reactive } from "vue";
import { useRoute } from "vue-router";
import { Auth } from "../auth/auth";
import axios from "axios";
import Cookies from 'js-cookie';
import { EUserFacePosition } from "@sgi/shared";
import type { IUser, IUserFacePopRes, IUserIdentificationPopRes, IUserMembershipHierarchyItem, IUserMembershipHierarchyResponse, IPaginatedResult, ISpaceTreeNode } from "@sgi/shared";


export interface DashboardHeaderOrganizationItem {
    id: string;
    name: string;
}


export interface DashboardGroup {
    title: string;
    items: DashboardGroupItem[];
}


export interface DashboardGroupItem {
    name: string;
    label: string;
    path: string;
    allowed_roles: Array<string>;
    icon: string;
    selected: boolean;
}


const DashboardAside = {

    /** Plegado del aside: true = rail de 64px solo-iconos; al hover se
     *  despliega FLOTANTE sobre el contenido (estilo dash.cloudflare.com).
     *  El boton toggle pliega/despliega de forma fija (pinned).
     *  Se PERSISTE en localStorage (sobrevive F5 / re-login). */
    collapsed: ((): boolean => {
        try {
            return localStorage.getItem('sgi.dashboard.aside.collapsed') === '1';
        } catch {
            return false;
        }
    })(),

    toggleCollapsed(): void {
        this.collapsed = !this.collapsed;
        try {
            localStorage.setItem('sgi.dashboard.aside.collapsed', this.collapsed ? '1' : '0');
        } catch { /* storage no disponible (modo privado) — queda en memoria */ }
    },

    all_groups: [

        {
            title: 'General',
            items: [
                {
                    name: 'Panel General',
                    label: 'Panel General',
                    path: '/panel-general',
                    allowed_roles: ['org:admin'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },
                {
                    name: 'Organizaciones',
                    label: 'Organizaciones',
                    path: '/organizaciones',
                    allowed_roles: ['sys:root', 'sys:admin'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M308 192h-40C261.4 192 256 197.4 256 204v40C256 250.6 261.4 256 268 256h40C314.6 256 320 250.6 320 244v-40C320 197.4 314.6 192 308 192zM308 288h-40C261.4 288 256 293.4 256 300v40C256 346.6 261.4 352 268 352h40C314.6 352 320 346.6 320 340v-40C320 293.4 314.6 288 308 288zM148 224h-40C101.4 224 96 229.4 96 236v40C96 282.6 101.4 288 108 288h40C154.6 288 160 282.6 160 276v-40C160 229.4 154.6 224 148 224zM308 96h-40C261.4 96 256 101.4 256 108v40C256 154.6 261.4 160 268 160h40C314.6 160 320 154.6 320 148v-40C320 101.4 314.6 96 308 96zM148 320h-40C101.4 320 96 325.4 96 332v40C96 378.6 101.4 384 108 384h40C154.6 384 160 378.6 160 372v-40C160 325.4 154.6 320 148 320zM404 96h-40C357.4 96 352 101.4 352 108v40C352 154.6 357.4 160 364 160h40C410.6 160 416 154.6 416 148v-40C416 101.4 410.6 96 404 96zM448 0H224C188.7 0 160 28.65 160 64v64H64C28.65 128 0 156.7 0 192v296C0 501.3 10.75 512 24 512s24-10.75 24-24V192c0-8.838 7.164-16 16-16h144V64c0-8.838 7.164-16 16-16h224c8.836 0 16 7.162 16 16v424c0 13.25 10.75 24 24 24S512 501.3 512 488V64C512 28.65 483.3 0 448 0zM404 192h-40C357.4 192 352 197.4 352 204v40C352 250.6 357.4 256 364 256h40C410.6 256 416 250.6 416 244v-40C416 197.4 410.6 192 404 192zM404 288h-40C357.4 288 352 293.4 352 300v40C352 346.6 357.4 352 364 352h40C410.6 352 416 346.6 416 340v-40C416 293.4 410.6 288 404 288z"/></svg>',
                    selected: false
                },
                {
                    name: 'Espacios',
                    label: 'Espacios',
                    path: '/espacios',
                    // M40.6: space:admin ve el árbol de su subárbol (SpaceExplorer)
                    allowed_roles: ['org:admin', 'space:admin'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },
            ]
        },

        {
            title: 'Monitoreo',
            items: [
                {
                    name: 'COS',
                    label: 'COS',
                    path: '/cos',
                    allowed_roles: ['org:cos', 'org:admin'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"/></svg>',
                    selected: false
                },
            ]
        },

        {
            title: 'Usuarios',
            items: [
                {
                    name: 'Membresias',
                    label: 'Membresias',
                    path: '/membresias',
                    // M40.4: space:admin gestiona las membresías de su subárbol
                    allowed_roles: ['sys:root', 'org:admin', 'space:admin'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },
                {
                    // M40.3: bandeja de solicitudes (claims por join code) —
                    // org:admin ve toda la org; space:admin solo su subárbol
                    // (scope automático por el header sgi-space-id)
                    name: 'Solicitudes',
                    label: 'Solicitudes',
                    path: '/solicitudes',
                    allowed_roles: ['sys:root', 'org:admin', 'space:admin'],
                    // M40.3b: icono fino minimalista (stroke, sin relleno) — el
                    // style inline le gana al fill del CSS del aside
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="fill:none;stroke:hsl(0,0%,40%);stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></svg>',
                    selected: false
                },
                {
                    name: 'Invitaciones',
                    label: 'Invitaciones',
                    path: '/invitaciones',
                    // M40.4: space:admin gestiona las invitaciones de su subárbol
                    allowed_roles: ['sys:root', 'org:admin', 'space:admin'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },
                // {
                //     name: 'Documentaciones',
                //     label: 'Documentaciones',
                //     path: '/tipos-identificacion',
                //     allowed_roles: ['org:admin'],
                //     icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                //     selected: false
                // },
                // {
                //     name: 'Plantilla de Datos',
                //     label: 'Plantilla de Datos',
                //     path: '/tipos-identificacion',
                //     allowed_roles: ['org:admin'],
                //     icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                //     selected: false
                // },
                {
                    name: 'Tipos de Identificación',
                    label: 'Tipos de Identificación',
                    path: '/tipos-identificacion',
                    allowed_roles: ['sys:root'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },
                {
                    name: 'Perfiles',
                    label: 'Perfiles',
                    path: '/perfiles',
                    allowed_roles: ['sys:root'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },
                {
                    name: 'Permisos',
                    label: 'Permisos',
                    path: '/permisos',
                    allowed_roles: ['sys:root'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },
            ]
        },

        // {
        //     title: 'Reportes',
        //     items: [
        //         {
        //             name: 'Reportes In/Out',
        //             label: 'Reportes In/Out',
        //             path: '/tipos-espacio',
        //             allowed_roles: ['sys:root', 'org:admin'],
        //             icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
        //             selected: false
        //         },            
        //         {
        //             name: 'Reportes Históricos',
        //             label: 'Reportes Históricos',
        //             path: '/paises',
        //             allowed_roles: ['sys:root', 'org:admin'],
        //             icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
        //             selected: false
        //         },
        //         {
        //             name: 'Reportes Varios',
        //             label: 'Reportes Varios',
        //             path: '/paises',
        //             allowed_roles: ['org:admin'],
        //             icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
        //             selected: false
        //         },
        //     ]
        // },
        

        {
            title: 'Flotas',
            items: [
                {
                    name: 'Listado de Vehiculos',
                    label: 'Vehiculos',
                    path: '/vehiculos',
                    allowed_roles: ['sys:root'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },
                {
                    name: 'Vehiculos',
                    label: 'Vehiculos',
                    path: '/vehiculos-membresias',
                    // M40.4: space:admin gestiona los vehículos de su subárbol
                    allowed_roles: ['org:admin', 'space:admin'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },         
                {
                    name: 'Tipos de Vehiculos',
                    label: 'Tipos',
                    path: '/vehiculos-tipos',
                    allowed_roles: ['sys:root'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },
                {
                    name: 'Marcas de Vehiculos',
                    label: 'Marcas',
                    path: '/vehiculos-marcas',
                    allowed_roles: ['sys:root'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },
                {
                    name: 'Modelos de Vehiculos',
                    label: 'Modelos',
                    path: '/vehiculos-modelos',
                    allowed_roles: ['sys:root'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },
                {
                    name: 'Perfiles de Vehiculos',
                    label: 'Perfiles',
                    path: '/vehiculos-perfiles',
                    allowed_roles: ['sys:root'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },
            ]
        },

        {
            title: 'Activos',
            items: [
                {
                    name: 'Listado de Activos',
                    label: 'Listado de Activos',
                    path: '/activos-listado',
                    allowed_roles: ['sys:root'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },
                {
                    name: 'Códigos de Emperajamiento',
                    label: 'Códigos de Empar.',
                    path: '/activos-emparejamiento',
                    allowed_roles: ['sys:root'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },
                {
                    name: 'Categorías de Activos',
                    label: 'Categorías',
                    path: '/activos-categorias',
                    allowed_roles: ['sys:root'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },
                {
                    name: 'Marcas de Activos',
                    label: 'Marcas',
                    path: '/activos-marcas',
                    allowed_roles: ['sys:root'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },
                {
                    name: 'Modelos de Activos',
                    label: 'Modelos',
                    path: '/activos-modelos',
                    allowed_roles: ['sys:root'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },
                // {
                //     name: 'Perfiles de Dispositivos',
                //     label: 'Perfiles',
                //     path: '/dispositivos-perfiles',
                //     allowed_roles: ['sys:root'],
                //     icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                //     selected: false
                // },
            ]
        },

        {
            title: 'Varios',
            items: [
                {
                    name: 'Tipos de Espacio',
                    label: 'Tipos de Espacio',
                    path: '/tipos-espacio',
                    allowed_roles: ['sys:root'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },            
                {
                    name: 'Paises',
                    label: 'Paises',
                    path: '/paises',
                    allowed_roles: ['sys:root'],
                    icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
                    selected: false
                },
            ]
        },

    ]as DashboardGroup[],

    all_items: [

        {
            name: 'Clientes',
            label: 'Clientes',
            path: '/clientes',
            allowed_roles: ['sys:root', 'org:admin'],
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M319.9 320c57.41 0 103.1-46.56 103.1-104c0-57.44-46.54-104-103.1-104c-57.41 0-103.1 46.56-103.1 104C215.9 273.4 262.5 320 319.9 320zM319.9 160c30.85 0 55.96 25.12 55.96 56S350.7 272 319.9 272S263.9 246.9 263.9 216S289 160 319.9 160zM512 160c44.18 0 80-35.82 80-80S556.2 0 512 0c-44.18 0-80 35.82-80 80S467.8 160 512 160zM369.9 352H270.1C191.6 352 128 411.7 128 485.3C128 500.1 140.7 512 156.4 512h327.2C499.3 512 512 500.1 512 485.3C512 411.7 448.4 352 369.9 352zM178.1 464c10.47-36.76 47.36-64 91.14-64H369.9c43.77 0 80.66 27.24 91.14 64H178.1zM551.9 192h-61.84c-12.8 0-24.88 3.037-35.86 8.24C454.8 205.5 455.8 210.6 455.8 216c0 33.71-12.78 64.21-33.16 88h199.7C632.1 304 640 295.6 640 285.3C640 233.8 600.6 192 551.9 192zM183.9 216c0-5.449 .9824-10.63 1.609-15.91C174.6 194.1 162.6 192 149.9 192H88.08C39.44 192 0 233.8 0 285.3C0 295.6 7.887 304 17.62 304h199.5C196.7 280.2 183.9 249.7 183.9 216zM128 160c44.18 0 80-35.82 80-80S172.2 0 128 0C83.82 0 48 35.82 48 80S83.82 160 128 160z"/></svg>',
            selected: false
        },

        {
            name: 'Organizaciones',
            label: 'Organiza.',
            path: '/organizaciones',
            allowed_roles: ['sys:root', 'org:admin'],
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M308 192h-40C261.4 192 256 197.4 256 204v40C256 250.6 261.4 256 268 256h40C314.6 256 320 250.6 320 244v-40C320 197.4 314.6 192 308 192zM308 288h-40C261.4 288 256 293.4 256 300v40C256 346.6 261.4 352 268 352h40C314.6 352 320 346.6 320 340v-40C320 293.4 314.6 288 308 288zM148 224h-40C101.4 224 96 229.4 96 236v40C96 282.6 101.4 288 108 288h40C154.6 288 160 282.6 160 276v-40C160 229.4 154.6 224 148 224zM308 96h-40C261.4 96 256 101.4 256 108v40C256 154.6 261.4 160 268 160h40C314.6 160 320 154.6 320 148v-40C320 101.4 314.6 96 308 96zM148 320h-40C101.4 320 96 325.4 96 332v40C96 378.6 101.4 384 108 384h40C154.6 384 160 378.6 160 372v-40C160 325.4 154.6 320 148 320zM404 96h-40C357.4 96 352 101.4 352 108v40C352 154.6 357.4 160 364 160h40C410.6 160 416 154.6 416 148v-40C416 101.4 410.6 96 404 96zM448 0H224C188.7 0 160 28.65 160 64v64H64C28.65 128 0 156.7 0 192v296C0 501.3 10.75 512 24 512s24-10.75 24-24V192c0-8.838 7.164-16 16-16h144V64c0-8.838 7.164-16 16-16h224c8.836 0 16 7.162 16 16v424c0 13.25 10.75 24 24 24S512 501.3 512 488V64C512 28.65 483.3 0 448 0zM404 192h-40C357.4 192 352 197.4 352 204v40C352 250.6 357.4 256 364 256h40C410.6 256 416 250.6 416 244v-40C416 197.4 410.6 192 404 192zM404 288h-40C357.4 288 352 293.4 352 300v40C352 346.6 357.4 352 364 352h40C410.6 352 416 346.6 416 340v-40C416 293.4 410.6 288 404 288z"/></svg>',
            selected: false
        },

        {
            name: 'Tipos de Espacio',
            label: 'Tipos de Espacio',
            path: '/tipos-espacio',
            allowed_roles: ['sys:root', 'org:admin'],
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
            selected: false
        },

        {
            name: 'Paises',
            label: 'Paises',
            path: '/paises',
            allowed_roles: ['sys:root', 'org:admin'],
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
            selected: false
        },

        {
            name: 'Tipos de Identificación',
            label: 'Tipos de Identificación',
            path: '/tipos-identificacion',
            allowed_roles: ['sys:root', 'org:admin'],
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
            selected: false
        },

        {
            name: 'Perfiles',
            label: 'Perfiles',
            path: '/perfiles',
            allowed_roles: ['sys:root', 'org:admin'],
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
            selected: false
        },

        {
            name: 'Permisos',
            label: 'Permisos',
            path: '/permisos',
            allowed_roles: ['sys:root', 'org:admin'],
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 12.5C5 12.8134 5.46101 13.3584 6.53047 13.8931C7.91405 14.5849 9.87677 15 12 15C14.1232 15 16.0859 14.5849 17.4695 13.8931C18.539 13.3584 19 12.8134 19 12.5V10.3287C17.35 11.3482 14.8273 12 12 12C9.17273 12 6.64996 11.3482 5 10.3287V12.5ZM19 15.3287C17.35 16.3482 14.8273 17 12 17C9.17273 17 6.64996 16.3482 5 15.3287V17.5C5 17.8134 5.46101 18.3584 6.53047 18.8931C7.91405 19.5849 9.87677 20 12 20C14.1232 20 16.0859 19.5849 17.4695 18.8931C18.539 18.3584 19 17.8134 19 17.5V15.3287ZM3 17.5V7.5C3 5.01472 7.02944 3 12 3C16.9706 3 21 5.01472 21 7.5V17.5C21 19.9853 16.9706 22 12 22C7.02944 22 3 19.9853 3 17.5ZM12 10C14.1232 10 16.0859 9.58492 17.4695 8.89313C18.539 8.3584 19 7.81342 19 7.5C19 7.18658 18.539 6.6416 17.4695 6.10687C16.0859 5.41508 14.1232 5 12 5C9.87677 5 7.91405 5.41508 6.53047 6.10687C5.46101 6.6416 5 7.18658 5 7.5C5 7.81342 5.46101 8.3584 6.53047 8.89313C7.91405 9.58492 9.87677 10 12 10Z"></path></svg>',
            selected: false
        },

        {
            name: 'Servicios',
            label: 'Servicios',
            path: '/servicios',
            allowed_roles: ['CLIENT', 'ADMIN'],
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M300.3 313.5C391.1 181.9 408 168.4 408 120C408 53.73 354.3 0 288 0C221.7 0 168 53.73 168 120c0 48.38 16.86 61.9 107.7 193.5C281.6 322.2 294.4 322.2 300.3 313.5zM248 112c0-22.09 17.91-40 40-40s40 17.91 40 40S310.1 152 288 152S248 134.1 248 112zM553.1 97.13l-115.1 42.57c-2.232 20.16-8.59 37.14-21.47 59.11L528 158v256.9l-128 44.63V226.2c-8.781 13.07-42.24 60.81-48 69.05v158.3l-128-45.25V295.3C218.2 287 184.8 239.3 176 226.2v176.5l-128 47.25V193.1l93.35-32.55C137.7 148 136 135.4 136 120c0-2.961 .707-5.727 .875-8.646L20.13 152C8 156.8 0 168.6 0 181.6v314.4c0 10.89 10.85 19.03 22 14.84L192 447.1l172 60.75c13 4.25 27 4.375 40 .125l151.9-52.88C568 451.2 576 439.4 576 426.4V112C576 101.1 565.2 92.94 553.1 97.13z"/></svg>',
            selected: false
        },

        {
            name: 'Dispositivos de Trabajo',
            label: 'Dispositivos de Trabajo',
            path: '/dispositivos-de-trabajo',
            allowed_roles: ['CLIENT', 'ADMIN'],
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M304 0h-224c-35.35 0-64 28.65-64 64v384c0 35.35 28.65 64 64 64h224c35.35 0 64-28.65 64-64V64C368 28.65 339.3 0 304 0zM320 448c0 8.822-7.178 16-16 16h-224C71.18 464 64 456.8 64 448V64c0-8.822 7.178-16 16-16h224C312.8 48 320 55.18 320 64V448zM224 400H160c-8.836 0-16 7.164-16 16s7.164 16 16 16h64c8.838 0 16-7.164 16-16S232.8 400 224 400z"/></svg>',
            selected: false
        },

        {
            name: 'Empleados',
            label: 'Empleados',
            path: '/empleados',
            allowed_roles: ['CLIENT', 'ADMIN'],
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M78.54 102.4v44.04C119.1 164.9 169.4 176 224 176s104.9-11.08 145.5-29.55V102.4l21.96-22.3c4.564-4.635 7.129-10.93 7.129-17.48c0-11.35-7.602-21.24-18.44-23.99l-148.3-37.67c-5.096-1.295-10.43-1.295-15.52 0l-148.3 37.67C57.06 41.39 49.46 51.28 49.46 62.62c0 6.555 2.564 12.85 7.129 17.48L78.54 102.4zM161.7 72.84c3.969-7.875 13.56-11.09 21.47-7.156L224 86.13l40.84-20.44c7.938-3.969 17.5-.75 21.47 7.156c3.938 7.906 .75 17.5-7.156 21.47l-48 24C228.9 119.4 226.4 120 224 120S219.1 119.4 216.8 118.3l-48-24C160.9 90.34 157.8 80.75 161.7 72.84zM319.7 352.5l-66.63 111L240 408l32-56h-96l32 56l-13.07 55.55l-66.63-111C57.05 355.2 0 413.4 0 485.3C0 500.1 11.94 512 26.66 512H421.3C436.1 512 448 500.1 448 485.3C448 413.4 390.1 355.2 319.7 352.5zM50.69 464c7.002-27.17 27.1-49.04 53.43-58.51L139.2 464H50.69zM308.8 464l35.11-58.51c26.33 9.469 46.43 31.34 53.43 58.51H308.8zM224 272c-41.23 0-74.9-31.51-79.15-71.64C128.1 197.1 112 192.8 96.45 187.5C96.4 189.1 96 190.5 96 192c0 70.69 57.31 128 127.1 128s127.1-57.31 127.1-128c0-1.525-.358-2.941-.4108-4.453C336 192.8 319.9 197.1 303.2 200.4C298.9 240.5 265.2 272 224 272z"/></svg>',
            selected: false
        },

        {
            name: 'Residentes',
            label: 'Residentes',
            path: '/residentes',
            allowed_roles: ['CLIENT', 'ADMIN'],
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M56 224C69.25 224 80 213.3 80 200v-144c0-4.4 3.6-8 8-8h464c4.4 0 8 3.6 8 8v144C560 213.3 570.7 224 584 224S608 213.3 608 200v-144C608 25.07 582.9 0 552 0H88C57.07 0 32 25.07 32 56v144C32 213.3 42.75 224 56 224zM544 256C508.8 256.2 480.2 284.7 480.2 320S508.8 383.8 544 383.1C579.2 383.8 607.8 355.3 607.8 320S579.2 256.2 544 256zM544.2 335.1C535.4 335.9 528.3 328.8 528.3 320c0-8.717 7.041-15.85 15.73-15.97C552.7 304.2 559.7 311.3 559.7 320C559.7 328.8 552.6 335.9 544.2 335.1zM343.8 416h-47.5C256.4 416 224 449.5 224 490.7C224 502.4 233.3 512 244.8 512h150.3C406.7 512 416 502.4 416 490.7C416 449.5 383.6 416 343.8 416zM567.8 416h-47.5C480.4 416 448 449.5 448 490.7C448 502.4 457.3 512 468.8 512h150.3C630.7 512 640 502.4 640 490.7C640 449.5 607.6 416 567.8 416zM256.2 320c0 35.26 28.57 63.85 63.79 63.98C355.2 383.8 383.8 355.3 383.8 320S355.2 256.2 320 256C284.8 256.2 256.2 284.7 256.2 320zM335.7 320c0 8.775-7.139 15.94-15.55 15.98C311.4 335.9 304.3 328.8 304.3 320c0-8.717 7.041-15.85 15.73-15.97C328.7 304.2 335.7 311.3 335.7 320zM119.8 416h-47.5C32.42 416 0 449.5 0 490.7C0 502.4 9.34 512 20.83 512h150.3C182.7 512 192 502.4 192 490.7C192 449.5 159.6 416 119.8 416zM32.21 320c0 35.26 28.57 63.85 63.79 63.98C131.2 383.8 159.8 355.3 159.8 320S131.2 256.2 96 256C60.78 256.2 32.21 284.7 32.21 320zM111.7 320c0 8.775-7.139 15.94-15.55 15.98C87.41 335.9 80.27 328.8 80.27 320c0-8.717 7.041-15.85 15.73-15.97C104.7 304.2 111.7 311.3 111.7 320z"/></svg>',
            selected: false
        },

        {
            name: 'Procedimientos',
            label: 'Procedim.',
            path: '/procedimientos',
            allowed_roles: ['CLIENT', 'ADMIN'],
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M64 112H512c8.8 0 16 7.2 16 16v91.6l6.6-6.6c11.6-11.6 26.3-18.5 41.4-20.5V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H330.5l6-23.9c2.2-8.8 6.2-17 11.8-24.1H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16zm56 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zM96 200c0 13.3 10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zm517.8 35.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"/></svg>',
            selected: false
        },

        {
            name: 'Alarmas',
            label: 'Alarmas',
            path: '/alarmas',
            allowed_roles: ['CLIENT', 'ADMIN'],
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M112 224.1c0-13.25-10.75-23.99-24-23.99h-64c-13.25 0-24 10.7-24 23.95s10.75 24.03 24 24.03h64C101.3 248.1 112 237.4 112 224.1zM90.75 108.2c7.125 5 16.38 5.874 24.25 1.999C122.9 106.4 128 98.7 128.5 89.95S124.8 72.75 117.3 68.13l-48-32C62.13 31 52.88 30.25 45 34C37.13 37.88 32 45.63 31.5 54.38s3.75 17.21 11.25 21.84L90.75 108.2zM536 112.2c4.75 0 9.375-1.372 13.25-3.997l48-31.98c7.375-4.625 11.62-13.09 11.12-21.84s-5.625-16.5-13.5-20.25c-7.75-3.75-17-3-24.12 1.875l-48 32c-8.875 5.875-12.75 17.08-9.625 27.2C516.1 105.2 525.5 112.2 536 112.2zM616 200.1h-64c-13.25 0-24 10.74-24 23.99s10.75 23.99 24 23.99h64c13.25 0 24-10.78 24-24.03S629.3 200.1 616 200.1zM496.9 336.1L460.5 141.7C455.5 115.2 432.4 96 405.4 96H234.6C207.6 96 184.5 115.2 179.5 141.7l-36.44 194.4C116.1 336.6 96 357.8 96 384v48C96 458.5 117.5 480 144 480h352c26.51 0 48-21.49 48-48V384C544 357.8 523 336.6 496.9 336.1zM226.7 150.5C227.4 146.8 230.7 144 234.6 144h170.9c3.844 0 7.156 2.75 7.875 6.5L448.1 336H191.9L226.7 150.5zM496 432h-352V384h352V432zM283.9 176.3C271.1 174.2 258.5 182.1 256.3 196.1l-16 96C238.2 305.1 246.1 317.5 260.1 319.7C261.4 319.9 262.7 320 264 320c11.53 0 21.69-8.312 23.66-20.06l16-96C305.8 190.9 297 178.5 283.9 176.3z"/></svg>',
            selected: false
        },

        {
            name: 'Audios',
            label: 'Audios',
            path: '/audios',
            allowed_roles: ['CLIENT', 'ADMIN'],
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.4 1.464l-144 35.38C185.1 41.09 176 53.34 176 67.34v299.1c-18.12-9.126-40.13-14.5-64-14.5c-61.88 0-112 35.88-112 80S50.13 512 112 512s112-35.87 112-80V195.4l137.6-33.38C375 157.7 384 145.5 384 131.5V31.98c0-10.25-4.938-19.81-13.19-25.81C362.6 .0373 352.1-1.536 342.4 1.464zM112 463.1c-39.75 0-64-20.75-64-31.1c0-11.25 24.25-32.01 64-32.01s64 20.75 64 32C176 443.2 151.8 463.1 112 463.1zM336 119.7L224 144.1V79.09l112-25.25V119.7z"/></svg>',
            selected: false
        }

    ] as Array<DashboardGroupItem>,

    items: [] as Array<DashboardGroupItem>,
    groups: [] as DashboardGroup[],
    
    async initialize(route?: ReturnType<typeof useRoute>): Promise<void> {

        // const route = useRoute();

        // await this.setItems();
        await this.setGroups();
        await this.setSelected(route);

    },

    async setItems(): Promise<void> {

        this.items = [];

        for(const i of this.all_items) {

            const res = await Auth.isAuthorized(i.allowed_roles);
            i.selected = false;
            if(res) this.items.push(i);

        }

    },

    async setGroups(): Promise<void> {

        this.groups = [];

        for(const g of this.all_groups) {

            const group: DashboardGroup = {
                title: g.title,
                items: []
            }

            for(const i of g.items) {
                const res = await Auth.isAuthorized(i.allowed_roles);
                i.selected = false;
                if(res) group.items.push(i);
            }

            this.groups.push(group);

        }

    },

    selected(item: DashboardGroupItem): void {

        // for(const i of this.items)
            // i.selected = false;

        for(const g of this.groups) {
            for(const i of g.items) {
                i.selected = false;
            }
        }

        item.selected = true;
        router.push(item.path);

        Dashboard.header.route.value = item.name;

    },

    async setSelected(route: any): Promise<void> {

        for(const g of this.groups) {

            for(const item of g.items) {

                // console.log(route.path, item.path)

                // if(route && route.path.indexOf(item.path) >= 0) {
                if(route && route.path && route.path == item.path) {
                    item.selected = true;
                    Dashboard.header.route.value = item.name;
                }

            }

        }

    }

}


const DashboardHeader = {

    user: {
        
        username: '',
        roles: '',
        is_root: false,
        is_client: false,
        is_admin: false,

        async set(): Promise<void> {

            const token = await Auth.getToken();
            this.username = '';
            this.roles = '';

            if(!token)
                return;

            // this.username = token.first_name.toUpperCase();

            // for(const [idx, e] of token.roles.entries()) {

            //     this.roles += `${e}`;

            //     if(idx < token.roles.length - 1)
            //         this.roles += ' - ';

            // }

        }

    },

    route: {
        value: ''
    },

    organizations: {

        values: [] as Array<DashboardHeaderOrganizationItem>,

        selected: {
            id: '',
            name: '',
        },

        async get(): Promise<void> {

            // const token = await Auth.getToken();
            // this.selected.id = '';
            // this.selected.name = '';
            // this.values = [];

            // return;

            // await axios.get(`/users/${token.id}/organizations`).then(res => {

                // for(const e of res.data) {
                    
                //     const org = {
                //         id: e._id,
                //         name: e.name
                //     }

                //     this.values.push(org);

                // }

                if(this.values.length > 0) {

                    const org_id = this.getCurrent();
                    let org = null;

                    if(org_id) {

                        org = this.values.find(x => x.id == org_id);

                        if(org) {
                            this.selected.id = org.id;
                            this.selected.name = org.name;
                        }

                    }

                    if(!org) {
                        this.selected.id = this.values[0].id;
                        this.selected.name = this.values[0].name;
                        this.setCurrent();
                    }

                }

            // }).catch(err => {

            //     console.dir(err);

            // })

        },

        getCurrent(): string | null {

            const org = Cookies.get('sgi-organization');
            if(!org) return null;
            return org;

        },

        setCurrent(reload?: boolean): void {

            console.log(this.selected.id);

            Cookies.set('sgi-organization', this.selected.id, {expires: 7, secure: true, sameSite: 'Lax'});
            if(reload) router.go(0);

        },
        
        reset(): void {

        },

        // change(): void {

        //     this.

        // }

    },

    async initialize(): Promise<void> {

        await this.organizations.get();
        this.user.set();

        // M33.1: el token ya no se usa aca (roles salen de getProfiles);
        // se conserva la llamada por si getToken tiene side effects.
        await Auth.getToken();
        // const user_roles = token.roles as Array<string>;
        const user_roles = await Auth.getProfiles();
        
        const a = ['sys:root', 'org:admin'];
        this.user.is_root = user_roles && user_roles.some(role => a.includes(role));
        this.user.is_admin = user_roles && user_roles.some(role => a.includes(role));

        this.user.is_client = user_roles.some(role => role == 'CLIENT');
        // this.user.is_admin = user_roles.some(role => role == 'org:admin');

    }

}


const DashboardSplash = {

    loading: true,
    not_organizations: false,

    async initialize(route?: ReturnType<typeof useRoute>): Promise<void> {
            
        this.loading = true;
        this.not_organizations = false;
        Dashboard.header.organizations.values = [];

        // M37: primero el usuario autenticado — funciona con o sin membresías
        // (la sección Mi cuenta/settings siempre queda disponible, §9.53)
        await axios.get('/auth/me').then(res => {
            Dashboard.user.setFromMe(res.data);
        }).catch(_ => {});

        // M37.5: rostros propios (avatar del header + menú de usuario) —
        // endpoint self-service @SkipPermissions, sirve con o sin membresías
        await axios.get('/user-faces/me').then(res => {
            Dashboard.user.setFaces(res.data);
        }).catch(_ => {});

        await axios.get('/user-memberships/me').then(res => {

            // const d: IPaginatedResult<IUserMembershipPopRes> = res.data;
            // const profiles = d.data.map(x => x.profile.code);
            // Cookies.set('sgi-user-profiles', JSON.stringify(profiles), {expires: 7, secure: true, sameSite: 'Lax'});
            // console.log(profiles);


            const d: IPaginatedResult<IUserMembershipHierarchyResponse> = res.data;

            // M37: sin membresías → estado vacío explícito (autenticación ≠ autorización)
            if(d.data.length == 0) {
                Dashboard.memberships.items = [];
                this.not_organizations = true;
                return;
            }

            const c = d.data[0];
            Dashboard.user.initialize(c);
            Dashboard.memberships.initialize(c);

            // const profiles: string[] = [];

            // for(const membership of c.memberships) {

            //     if(membership.organization.id != null) {

            //         Dashboard.header.organizations.values.push({
            //             id: membership.organization.id,
            //             name: membership.organization.name
            //         })

            //         for(const space of membership.spaces) {
                        
            //             if(space.id == null) {

            //                 for(const profile of space.profiles) {

            //                     profiles.push(profile.code);

            //                 }

            //             }

            //         }

            //     }

            // }

            // Cookies.set('sgi-user-profiles', JSON.stringify(profiles), {expires: 7, secure: true, sameSite: 'Lax'});
            // console.log(profiles);

        }).catch(_ => {

            // M37: 403/404 = sin membresías (o sin permiso para listarlas) → estado vacío
            Dashboard.memberships.items = [];
            this.not_organizations = true;

        });

        // console.log(route.path)

        // router.replace({name: 'Dashboard'})
        // router.replace({path: route.path});

        await Dashboard.aside.initialize(route);
        await Dashboard.header.initialize();

        // M37.5/M37.6: redirecciones de estado dentro del layout. Solo si la
        // ruta actual no es "always_available" (settings y las propias vistas
        // NoMemberships/NoSections quedan donde están).
        if(route && !route.meta.always_available) {

            if(this.not_organizations) {

                router.replace({ name: 'NoMemberships' }).catch(_ => {});

            } else if(!Dashboard.aside.groups.some(g => g.items.length > 0)) {

                // M37.6: tiene membresías pero ninguna sección del aside le
                // está habilitada por perfil (ej. solo org:member)
                router.replace({ name: 'NoSections' }).catch(_ => {});

            }

        }

        // console.log(Dashboard.header.organizations.selected.name);

        // if(!Dashboard.header.user.is_root && Dashboard.header.organizations.values.length == 0)
        // // if(Dashboard.header.organizations.values.length == 0)
        //     this.not_organizations = true;

        setTimeout(() => {
            this.loading = false;
        }, 300);


    },

    retry(): void {

        router.go(0);

    }

}


const DashboardMemberships = {

    items: [] as IUserMembershipHierarchyItem[],

    /** M40.2: membresías CRUDAS del hierarchy (sin filtrar a org-level) —
     *  el selector de space necesita las entradas per-space (x.id != null)
     *  que items[] descarta. */
    raw: [] as IUserMembershipHierarchyItem[],

    /** M37.6c: perfiles por organización computados de TODOS los spaces del
     *  hierarchy (org-level Y per-space). Clave: org id ('sgi-organization-system'
     *  para la entrada de sistema). Los items[] filtran spaces a org-level
     *  (x.id == null) para el selector, pero ese filtro PERDÍA los perfiles
     *  asignados por space (org:cos per-space de M32) → la cookie
     *  sgi-user-profiles quedaba incompleta y el home/redirect salía mal
     *  de forma intermitente según cómo estuviera asignado el perfil. */
    profiles_by_org: {} as Record<string, string[]>,

    /** M40.2: perfiles SOLO org-level por org (entries x.id == null) y
     *  perfiles por space id (entries per-space) — la cookie de contexto
     *  se computa con estos dos mapas según el space seleccionado. */
    profiles_org_level: {} as Record<string, string[]>,
    profiles_by_space: {} as Record<string, string[]>,

    /** M37.6c: cantidad de membresías CRUDAS del hierarchy (sin filtrar) —
     *  para distinguir "sin membresías" de "membresías solo per-space" */
    total_memberships: 0,

    current: {
        organization: {
            id: null,
            name: '',
        },
        spaces: []
    } as IUserMembershipHierarchyItem,

    /** M40.2: space seleccionado en el header (null = "Toda la organización"
     *  — solo disponible si el user tiene membresía org-level en la org). */
    current_space: {
        id: null as string | null,
        name: '',
    },

    /** M40.7: bosque de spaces administrables para el selector del header
     *  (SgiSpaceSelect con árbol). M40.7b (fix de campo): SOLO los spaces
     *  donde el usuario tiene perfil space:admin (spaceOptions ya filtra —
     *  M40.2c); antes se cargaba el árbol COMPLETO de la org y el selector
     *  mostraba todos los spaces. Se pide un subárbol por raíz administrable
     *  (?root= — funciona con cualquier space en contexto, el backend valida
     *  pertenencia a la org) y se PODA cada subárbol a los ids administrables:
     *  un space:admin de Torre A NO ve los dto de Torre A salvo que también
     *  los administre. */
    space_tree: [] as ISpaceTreeNode[],
    space_tree_loading: false,

    async loadSpaceTree(): Promise<void> {

        this.space_tree = [];

        const org_id = this.current.organization.id;
        if(!org_id || org_id === 'sgi-organization-system') return;

        const admin_ids = new Set(
            this.spaceOptions().filter(o => o.id != null).map(o => o.id as string)
        );
        if(admin_ids.size === 0) return;

        if(this.space_tree_loading) return;
        this.space_tree_loading = true;

        try {

            const trees = await Promise.all(
                [...admin_ids].map(id =>
                    axios.get('/spaces/tree', { params: { root: id } })
                        .then(r => r.data as ISpaceTreeNode[]))
            );

            // poda: solo spaces administrables, preservando el anidado
            // cuando padre e hijo son ambos administrables
            const prune = (nodes: ISpaceTreeNode[]): ISpaceTreeNode[] =>
                nodes
                    .filter(n => admin_ids.has(n.id))
                    .map(n => ({ ...n, children: prune(n.children) }));

            const pruned = trees.map(t => prune(t)).filter(t => t.length > 0);

            // dedup: una raíz administrable que cuelga de otra ya viene
            // anidada en el árbol de esa otra — no duplicarla como raíz
            const collect = (nodes: ISpaceTreeNode[], set: Set<string>): void =>
                nodes.forEach(n => { set.add(n.id); collect(n.children, set); });
            const id_sets = pruned.map(t => { const s = new Set<string>(); collect(t, s); return s; });

            this.space_tree = pruned
                .filter((t, i) => !pruned.some((_, j) => j !== i && id_sets[j].has(t[0].id)))
                .map(t => t[0]);

        } catch (err) {

            console.error(err);
            this.space_tree = [];

        } finally {

            this.space_tree_loading = false;

        }

    },

    async initialize(data: IUserMembershipHierarchyResponse): Promise<void> {

        this.setItems(data);
        this.setCurrentInit();

    },

    /** M37.6c: perfiles de una org desde el mapa completo (org-level + per-space) */
    profilesOf(org_id: string | null): string[] {

        return this.profiles_by_org[org_id ?? 'sgi-organization-system'] ?? [];

    },

    /** M40.2: membresía cruda de una org (clave unificada con system) */
    rawOf(org_id: string | null): IUserMembershipHierarchyItem | null {

        const key = org_id ?? 'sgi-organization-system';
        return this.raw.find(m => (m.organization.id ?? 'sgi-organization-system') === key) ?? null;

    },

    /** M40.2: opciones del selector de space de la org actual —
     *  "Toda la organización" (null) SOLO si hay membresía org-level.
     *  M40.2c (fix de campo): los items per-space SOLO donde el usuario
     *  tiene un perfil `space:admin` — el selector es para ADMINISTRAR el
     *  space; membresías per-space de otro tipo (p.ej. space:access, el
     *  operador COS) no generan opción. */
    spaceOptions(): Array<{ id: string | null, name: string }> {

        const org_id = this.current.organization.id;
        if (!org_id) return [];

        const raw = this.rawOf(org_id === 'sgi-organization-system' ? null : org_id);
        if (!raw) return [];

        const has_org_level = raw.spaces.some(x => x.id == null);
        const options: Array<{ id: string | null, name: string }> = raw.spaces
            .filter(x => x.id != null && x.profiles.some(p => p.code === 'space:admin'))
            .map(x => ({ id: x.id as string, name: x.name }));

        if (has_org_level)
            options.unshift({ id: null, name: 'Toda la organización' });

        return options;

    },

    /** M40.2: perfiles del contexto actual para la cookie sgi-user-profiles.
     *  M40.2b (fix de campo): con space seleccionado SOLO los perfiles de ESE
     *  space — el selector es un cambio de contexto operativo, no una unión:
     *  un org:admin que entra a un space NO ve las secciones org-level (para
     *  eso vuelve a "Toda la organización"). Sin space seleccionado, status
     *  quo M37.6c (org-level + TODOS los per-space de la org). */
    contextProfiles(): string[] {

        const org_id = this.current.organization.id;
        if (!org_id) return [];

        if (this.current_space.id)
            return this.profiles_by_space[this.current_space.id] ?? [];

        return this.profilesOf(org_id);

    },

    setItems(data: IUserMembershipHierarchyResponse) {

        this.items = [];
        this.raw = data.memberships;
        this.profiles_by_org = {};
        this.profiles_org_level = {};
        this.profiles_by_space = {};
        this.total_memberships = data.memberships.length;
        let item_system: IUserMembershipHierarchyItem|null = null;

        for(const membership of data.memberships) {

            // M37.6c: perfiles de TODOS los spaces (antes de filtrar org-level)
            const org_key = membership.organization.id ?? 'sgi-organization-system';
            const profiles = membership.spaces.flatMap(x => x.profiles.map(p => p.code));
            this.profiles_by_org[org_key] = [...new Set([...(this.profiles_by_org[org_key] ?? []), ...profiles])];

            // M40.2: mapas separados org-level / per-space para la cookie de contexto
            for(const space of membership.spaces) {
                const codes = space.profiles.map(p => p.code);
                if(space.id == null) {
                    this.profiles_org_level[org_key] = [...new Set([...(this.profiles_org_level[org_key] ?? []), ...codes])];
                } else {
                    this.profiles_by_space[space.id] = [...new Set([...(this.profiles_by_space[space.id] ?? []), ...codes])];
                }
            }

            if(membership.organization.id != null) {

                const e: IUserMembershipHierarchyItem = {
                    organization: {
                        id: membership.organization.id,
                        name: membership.organization.name
                    },
                    spaces: membership.spaces.filter(x => x.id == null)
                }

                // M40.2: la org entra al selector aunque solo tenga membresías
                // per-space (space:admin puro — sin esto quedaba sin contexto)
                if(membership.spaces.length > 0)
                    this.items.push(e);

            }else {

                const e: IUserMembershipHierarchyItem = {
                    organization: {
                        id: 'sgi-organization-system',
                        name: 'SGI - Sistema'
                    },
                    spaces: membership.spaces.filter(x => x.id == null)
                }

                if(membership.spaces.length > 0)
                    item_system = e;

            }

        }

        if(item_system)
            this.items.unshift(item_system);

    },

    setCurrentInit() {

        if(this.items.length == 0) {

            // M37.6c: "sin membresías" SOLO si el hierarchy vino vacío de
            // verdad. Con membresías exclusivamente per-space el selector
            // de orgs queda vacío (brecha pre-existente del filtro
            // org-level) pero el usuario SÍ tiene membresías → no es
            // not_organizations (caerá en sin-secciones por aside vacío)
            if(this.total_memberships === 0)
                Dashboard.splash.not_organizations = true;
            return;
        }

        if(this.items.length > 0) {

            const org_id = this.getCurrentId();
            let membership = null;

            if(org_id) {

                membership = this.items.find(x => x.organization.id == org_id);

                if(membership) {
                    this.current = membership;
                }

            }

            if(!membership) {
                this.current = this.items[0];
                this.setCurrentId();
            }

        }

        // M40.2: resolver el space seleccionado (cookie sgi-space-id) contra
        // las opciones de la org actual; default = primera opción ("Toda la
        // organización" si hay membresía org-level, si no el primer space).
        const space_options = this.spaceOptions();

        if(space_options.length > 0) {

            const space_id = this.getCurrentSpaceId();
            let option = space_id ? space_options.find(x => x.id === space_id) : null;

            if(!option) option = space_options[0];

            this.current_space = { id: option.id, name: option.name };

            // Normaliza la cookie si el space guardado ya no existe en la org
            if(String(option.id) !== String(space_id))
                this.writeSpaceCookie(option.id);

        } else {

            this.current_space = { id: null, name: '' };
            this.writeSpaceCookie(null);

        }

        // M40.2: perfiles del CONTEXTO (org-level + space seleccionado; sin
        // space, status quo M37.6c: org-level + todos los per-space)
        const profiles: string[] = this.contextProfiles();

        Cookies.set('sgi-user-profiles', JSON.stringify(profiles), {expires: 7, secure: true, sameSite: 'Lax'});
        console.log(profiles);

        // M40.7: bosque del selector de space del header (fire-and-forget)
        this.loadSpaceTree();

    },

    /** M40.2: space actual desde la cookie (null = toda la organización) */
    getCurrentSpaceId(): string | null {

        return Cookies.get('sgi-space-id') ?? null;

    },

    /** M40.2: escribe/borra la cookie del space seleccionado */
    writeSpaceCookie(id: string | null): void {

        if(id)
            Cookies.set('sgi-space-id', id, {expires: 7, secure: true, sameSite: 'Lax'});
        else
            Cookies.remove('sgi-space-id');

    },

    /** M40.2: cambio de space en el selector — misma mecánica que el cambio
     *  de org: pre-setea cookies (space + perfiles del contexto nuevo) y
     *  recarga sobre el home calculado con esos perfiles. */
    setCurrentSpaceId(reload?: boolean): void {

        const id = this.current_space.id;

        this.writeSpaceCookie(id);

        const profiles: string[] = this.contextProfiles();
        Cookies.set('sgi-user-profiles', JSON.stringify(profiles), {expires: 7, secure: true, sameSite: 'Lax'});

        if(reload) {

            const home = Dashboard.homePath();

            router.replace({ path: home }).then(() => {
                window.location.reload();
            }).catch(() => {
                window.location.href = router.resolve({ path: home }).href;
            });

        }

    },

    getCurrentId(): string | null {

        const org = Cookies.get('sgi-organization');
        if(!org) return null;
        return org;

    },

    setCurrentId(reload?: boolean): void {

        const id = this.current.organization.id;
        console.log(id);

        if(id == null) return;

        Cookies.set('sgi-organization', id, {expires: 7, secure: true, sameSite: 'Lax'});

        // M40.2: al cambiar de org el space seleccionado no aplica (los
        // spaces son de la org anterior) → se resetea; tras el reload,
        // setCurrentInit lo resuelve al default de la org nueva
        this.current_space = { id: null, name: '' };
        Cookies.remove('sgi-space-id');

        // if(reload) router.go(0);
        if (reload) {

            // M37.5b: el home debe calcularse con los perfiles de la NUEVA
            // organización. La cookie sgi-user-profiles todavía tiene los de
            // la org anterior (se reescribe en setCurrentInit DESPUÉS del
            // reload) → con la cookie vieja el redirect salía invertido.
            // M37.6c: se leen del mapa profiles_by_org (incluye per-space;
            // antes se tomaban de items[].spaces, filtrados a org-level)
            const profiles: string[] = this.profilesOf(id);

            // Pre-seteamos la cookie: tras el reload, el redirect de '/' y
            // el guard de rutas ya leen los perfiles correctos (setCurrentInit
            // los vuelve a escribir con el mismo valor desde el servidor)
            Cookies.set('sgi-user-profiles', JSON.stringify(profiles), {expires: 7, secure: true, sameSite: 'Lax'});

            // M37.5: home según perfiles (un usuario solo-org:cos vuelve a
            // COS al cambiar de organización, no a membresías)
            const home = Dashboard.homePath();

            // Navegamos a la ruta deseada y luego recargamos
            router.replace({ path: home }).then(() => {
                window.location.reload();
            }).catch(() => {
                // Fallback si el replace falla (incluye navegación redundante)
                window.location.href = router.resolve({ path: home }).href;
            });
        }

    },

}


const DashboardUser = {

    data: {
        id: '',
        // M37: display — primary derivado de emails (/auth/me) o el email
        // escalar computado por el pipeline de membresías (§9.53)
        email: '',
        first_name: '',
        last_name: '',
        identifications: [] as IUserIdentificationPopRes[],
        // M37.5: rostros propios (GET /user-faces/me — media populado)
        faces: [] as IUserFacePopRes[],
        updated_at: '',
        created_at: ''
    },

    /** M37: fuente GET /auth/me — funciona con o sin membresías (settings siempre disponible) */
    setFromMe(user: IUser): void {

        this.data.id = user.id;
        this.data.first_name = user.first_name;
        this.data.last_name = user.last_name;
        this.data.email = user.emails?.find(e => e.primary)?.email ?? '';
        this.data.identifications = (user.identifications ?? []) as unknown as IUserIdentificationPopRes[];

    },

    /** M37.5: fuente GET /user-faces/me (self-service, @SkipPermissions) */
    setFaces(faces: IUserFacePopRes[]): void {

        this.data.faces = faces ?? [];

    },

    /** M37.5: avatar del header — primer FRONT; si no hay, el primero que exista */
    frontFaceUrl(): string {

        const faces = this.data.faces ?? [];
        const front = faces.find(f => f.position === EUserFacePosition.FRONT);
        return front?.media?.s3_url ?? faces[0]?.media?.s3_url ?? '';

    },

    /** M37.5: "Apellido, Nombre" para el menú de usuario (vacío si no hay datos) */
    fullName(): string {

        return [this.data.last_name, this.data.first_name]
            .filter(x => !!x?.trim())
            .join(', ');

    },

    /** M37.5: primer documento formateado "ARG - DNI - XXXXXXX"
     *  (/auth/me M37.5 ya devuelve identifications populadas) */
    primaryDocument(): string {

        const doc = this.data.identifications?.[0];
        if(!doc) return '';

        const country = (doc.country?.iso_alpha3 ?? doc.country?.iso_alpha2 ?? '').toUpperCase();
        // M37.5b: common_code (código público del tipo), no sys_code interno
        const type = doc.type?.common_code ?? '';

        return [country, type, doc.number].filter(x => !!x).join(' - ');

    },

    async initialize(data: IUserMembershipHierarchyResponse): Promise<void> {

        this.setData(data);

    },


    setData(data: IUserMembershipHierarchyResponse) {

        this.data.id = data.user.id;
        this.data.first_name = data.user.first_name;
        this.data.last_name = data.user.last_name;
        this.data.email = data.user.email ?? '';

    }

}


export const Dashboard = reactive({

    loading: false,
    aside: DashboardAside,
    header: DashboardHeader,
    splash: DashboardSplash,
    user: DashboardUser,
    memberships: DashboardMemberships,

    /**
     * M37.5/M37.6: ruta home según perfiles (cookie sgi-user-profiles — ya
     * seteada por setCurrentInit durante el splash del login, o por
     * setCurrentId al cambiar de organización). Misma lógica que el redirect
     * de la ruta Dashboard en routes.ts, con fallback genérico: primer item
     * del aside visible para los perfiles; si no hay ninguno → sin-secciones.
     */
    homePath(): string {

        const raw = Cookies.get('sgi-user-profiles');
        const profiles: string[] = raw ? JSON.parse(raw) : [];

        if (profiles.length === 0)
            return '/sin-membresias';

        if (profiles.every(p => p === 'org:cos'))
            return '/cos';

        if (profiles.some(p => p === 'sys:root' || p === 'org:admin'))
            return '/membresias';

        // M37.6: primer item del aside habilitado para estos perfiles
        // (cubre sys:admin → Organizaciones y cualquier rol futuro)
        const first = this.aside.all_groups
            .flatMap(g => g.items)
            .find(i => i.allowed_roles.length === 0 || profiles.some(p => i.allowed_roles.includes(p)));

        return first ? first.path : '/sin-secciones';

    },

})